import { createSlice } from '@reduxjs/toolkit'

export const CampaignAllSlice = createSlice({
  name: 'campaign_all_filter',
  initialState: {
    value: false,
  },
  reducers: {
    setCampaignAllFilter: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { setCampaignAllFilter } = CampaignAllSlice.actions

export default CampaignAllSlice.reducer